import React from 'react';
import ImageBa from '../assets/ciudad-ba.svg';
import ImageBa2 from '../assets/vamos-ba.svg';
function Footer() {
  return (
   <>
    <h2 className="sr-only">Navegación de pie de página</h2>
    <footer className="main-footer">
      <div className="container">
        <section className="footer-legal-section">
          <h3 className="sr-only">Información gubernamental</h3>
          <div className="row align-items-center">
            <div className="col-12 col-md-5 col-xl-4 footer-content-img">
              <img
                className="d-lg-none"
                src={ImageBa}
                alt="Logo de Ciudad de Buenos Aires"
                height="48"
              />
              <img
                className="d-none d-lg-inline"
                src={ImageBa}
                alt="Logo de Ciudad de Buenos Aires"
                height="40"
              />
              <img
                className="img-vamos-ba"
                src={ImageBa2}
                alt="Logo de Vamos Buenos Aires"
              />
            </div>
            <div className="col-12">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <a href="https://boletinoficial.buenosaires.gob.ar">
                    Boletín oficial
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://buenosaires.gob.ar/inicio/terminos-y-condiciones"
                  >
                    Términos y condiciones
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://buenosaires.gob.ar/inicio/privacidad">
                    Política de privacidad
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="https://buenosaires.gob.ar/jefedegobierno/legalytecnica/normativa/boletin-oficial-y-registro/oficios-judiciales"
                  >
                    Oficios judiciales
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.buenosaires.gob.ar/gobierno/transparencia">
                    Transparencia
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section>
          <div className="footer-license-text">
            Los contenidos de buenosaires.gob.ar están licenciados bajo Creative
            Commons Reconocimiento 2.5 Argentina License.
          </div>
        </section>
      </div>
    </footer>
 </>
  )
}

export default Footer